import { ApiClient } from '@/api/client';
import createKeyFactory, { KEYS } from 'utils/createKeyFactory';

export type EventLocatorFilter = Partial<Parameters<ApiClient['events']['apiEventslocatorGetCollection']>[0]>;
export type EventFilter = Partial<Parameters<ApiClient['events']['apiEventsGetCollection']>[0]>;
export type MyEventFilter = Partial<Parameters<ApiClient['myEvents']['apiMyEventsGetCollection']>[0]>;

export const eventsFactory = {
  ...createKeyFactory([KEYS.EVENTS]),
  locator: (params?: EventLocatorFilter) => [...eventsFactory.all(), 'locator', ...eventsFactory.list(params)],
  myEvents: (params?: MyEventFilter) => [...eventsFactory.all(), 'myEvents', ...eventsFactory.list(params)],
};

export const eventUsersFactory = {
  ...createKeyFactory([KEYS.EVENT_USERS]),
};

export const eventsTypesFactory = {
  ...createKeyFactory([KEYS.EVENT_TYPES]),
  shop: () => [...eventsTypesFactory.all(), 'shop', ...eventsTypesFactory.list()],
};
